module.exports = __webpack_public_path__ + "img/service-icon3.8617de36.png";